import React from "react";
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { EconActivityLinkViewController, EconActivityLinkViewControllerDelegate } from "../../Screen/EconActivityLink/EconActivityLinkViewController";
import { EconActivityLinkViewModel } from "../../Screen/EconActivityLink/EconActivityLinkViewModel";
import { TableGenericViewController, TableGenericViewControllerDelegate } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import ProtectedRoute from "../../Components/ProtectedRoute";

export class EconActivityLinkCoordinator implements EconActivityLinkViewControllerDelegate, IndexCoordinatorDelegate, TableGenericViewControllerDelegate {
    getRoute(): JSX.Element[]{
        return[
            this.routeForm(),
            this.routeTable()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geppessoaatividadeseconomicas")
        return (<ProtectedRoute requiredPermissions={['info_bas.ativ_econ.*']} path="/:base/pessoa/:id/atividades-economicas" exact={true} component={(props:any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'info_bas.ativ_econ.adicionar',
                    edit: 'info_bas.ativ_econ.editar',
                    delete: 'info_bas.ativ_econ.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Atividades Econômicas - Pessoa"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new EconActivityLinkViewModel()
        return (<ProtectedRoute requiredPermissions={['info_bas.ativ_econ.adicionar', 'info_bas.ativ_econ.editar']} path="/:base/pessoa/:idpessoa/atividades-economicas/cad/:id" exact={true} component={(props:any) => {
            var idPk = props.match.params.id
            var idPerson = props.match.params.idpessoa
            return (<EconActivityLinkViewController  
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idPerson={idPerson}
            />)
        }}/>)
    }

    tapDimiss(navigation: any): void{
        navigation.history.goBack();
    }

    tapEconActivity(navigation: any, id: number): void {
        if(id > 0) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/pessoas/${id}/atividades-economicas`);
        }
    }

    add(navigation: any, viewModel: TableGenericViewModel): void{
        if(viewModel.getTable() == "geppessoaatividadeseconomicas"){
            navigation.history.push(`atividades-economicas/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void{
        if(viewModel.getTable() == "geppessoaatividadeseconomicas"){
            navigation.history.push(`atividades-economicas/cad/${idSelection}`);
            return;
        }
    }
}